export default {
  JOIN_URL: '/teams-creation/join/',
  TEAMS_CREATION: '/teams-creation/',
  TEAMS: '/team/',
  FRP: '/fundraising/',
  FRP_CREATION: '/fundraising-page/creation',
};
